import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from "@angular/router";
import { isEqual } from "lodash";

export class AppRouteReuseStrategy extends RouteReuseStrategy {

    shouldDetach(route: ActivatedRouteSnapshot) { return false; }

    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null) { }

    shouldAttach(route: ActivatedRouteSnapshot) { return false; }

    retrieve(route: ActivatedRouteSnapshot) { return null; }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot) {
        return future.routeConfig === curr.routeConfig && isEqual(future.params, curr.params);
    }
}